import { Fragment, useEffect, useState } from 'react'
import Select from 'react-select'
import { getPartyStatementApi } from '../api/api.js'

const fmt = (v) => (v != null && v !== '' ? Number(v).toFixed(2) : '—')

const ALL_PARTIES_OPTION = { value: '', label: 'All Parties' }

const FIELDS = [
  { key: 'partyName', label: 'Party Name' },
  { key: 'pendingAmountAgstLoan', label: 'Pending Amount Agst Loan' },
  { key: 'pendingAmountWithoutBora', label: 'Pending Amount Without Bora' },
  { key: 'interestTillDate', label: 'Interest Till Date' },
  { key: 'rentTillDate', label: 'Rent till Date' },
  { key: 'pendingAmountOfBora', label: 'Pending Amount of Bora' },
  { key: 'balanceStock', label: 'Balance Stock' },
  { key: 'grandTotal', label: 'Grand Total' },
  { key: 'balanceAsPerBook', label: 'Balance As Per Book' },
]

export default function PartyWiseStatement() {
  const [partyOptions, setPartyOptions] = useState([ALL_PARTIES_OPTION])
  const [selectedParty, setSelectedParty] = useState(ALL_PARTIES_OPTION)
  const [rows, setRows] = useState([])
  const [loading, setLoading] = useState(true)
  const [loadingParties, setLoadingParties] = useState(true)

  // Load party names for dropdown (fetch once with high limit)
  useEffect(() => {
    setLoadingParties(true)
    getPartyStatementApi({ page: 1, limit: 2000 })
      .then((res) => {
        const payload = res.data?.data ?? res.data
        const list = Array.isArray(payload) ? payload : (payload?.rows ?? [])
        const names = [...new Set(list.map((r) => r.partyName).filter(Boolean))].sort()
        setPartyOptions([
          ALL_PARTIES_OPTION,
          ...names.map((n) => ({ value: n, label: n })),
        ])
      })
      .catch(() => setPartyOptions([ALL_PARTIES_OPTION]))
      .finally(() => setLoadingParties(false))
  }, [])

  // Load data when selection changes
  useEffect(() => {
    setLoading(true)
    const params = { page: 1, limit: 2000 }
    if (selectedParty?.value) params.partyName = selectedParty.value
    getPartyStatementApi(params)
      .then((res) => {
        const payload = res.data?.data ?? res.data
        const list = Array.isArray(payload) ? payload : (payload?.rows ?? [])
        setRows(list)
      })
      .catch(() => setRows([]))
      .finally(() => setLoading(false))
  }, [selectedParty])

  const getValue = (row, key) =>
    key === 'partyName' ? (row.partyName ?? '—') : fmt(row[key])

  return (
    <div className="card">
      <h2>Party Wise Statement</h2>

      <div className="mb-3" style={{ maxWidth: '320px' }}>
        <label className="form-label small fw-500 mb-2 d-block">Party Name</label>
        <Select
          options={partyOptions}
          value={selectedParty}
          onChange={(opt) => setSelectedParty(opt || ALL_PARTIES_OPTION)}
          placeholder="Select Party"
          isClearable={false}
          isSearchable={true}
          isLoading={loadingParties}
          className="react-select-container"
          classNamePrefix="react-select"
        />
      </div>

      {loading ? (
        <p className="text-muted">Loading...</p>
      ) : rows.length === 0 ? (
        <p className="text-muted">No records available</p>
      ) : (
        <div className="table-wrap" style={{ width: '100%', maxWidth: '600px' }}>
          <table className="table table-bordered" style={{ tableLayout: 'fixed' }}>
            <tbody>
              {rows.map((row, rowIdx) => (
                <Fragment key={row.id || rowIdx}>
                  {FIELDS.map((f) => (
                    <tr key={f.key}>
                      <td
                        style={{
                          width: '45%',
                          fontWeight: 600,
                          backgroundColor: '#f8f9fa',
                          verticalAlign: 'middle',
                        }}
                      >
                        {f.label}
                      </td>
                      <td style={{ width: '55%', textAlign: 'right', verticalAlign: 'middle' }}>
                        {getValue(row, f.key)}
                      </td>
                    </tr>
                  ))}
                  {rows.length > 1 && rowIdx < rows.length - 1 && (
                    <tr>
                      <td colSpan={2} style={{ height: '12px', backgroundColor: '#e9ecef', border: 'none' }} />
                    </tr>
                  )}
                </Fragment>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  )
}
